import React, { useEffect } from 'react';
import styles from './curso_isabellacoimbra_sobrancelhas.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5517988130264';

const APRENDER = [
    'Biossegurança',
    'Aplicação correta da Henna',
    'Finalização profissional',
    'Técnica Ombre Henna',
    'Colorimetria completa',
    'Como agregar valor ao seu atendimento',
    'Posicionamento profissional',
    'Atendimento e experiência da cliente',
];

const INCLUSO = [
    'Material utilizado durante o curso',
    'Certificado com CNPJ',
    'Kit brinde exclusivo',
    'Mimo especial para aluna',
];

const Curso_isabellacoimbra_sobrancelhas: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openWhatsApp = () => {
        window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank');
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.curso_isabellacoimbra_sobrancelhas}>
                <div className={styles.header}>
                    <Link to="/isabellacoimbra_sobrancelhas" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Curso</h2>
                </div>

                <div className={styles.hero}>
                    <img
                        src={require('./src/curso.png')}
                        alt="Kit brinde exclusivo Isabella Coimbra Studio Beauty"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <section className={styles.section}>
                        <p className={styles.eyebrow}>Design de Sobrancelhas com Henna</p>
                        <p className={styles.lead}>
                            O Curso de Design de Sobrancelhas com Henna foi desenvolvido para profissionais iniciantes
                            ou para quem deseja aperfeiçoar sua técnica e oferecer um atendimento mais profissional e
                            valorizado.
                        </p>
                        <p className={styles.paragraph}>
                            Durante 2 dias intensivos, você aprenderá desde a base da biossegurança até técnicas de
                            aplicação, acabamento e valorização do serviço.
                        </p>
                        <p className={styles.highlight}>
                            Aqui você não aprende apenas “fazer sobrancelha”.
                            <br />
                            Você aprende a entregar experiência, resultado e profissionalismo.
                        </p>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>Informações do curso</h3>
                        <div className={styles.infoRow}>
                            <div>
                                <span className={styles.infoLabel}>Duração</span>
                                <span className={styles.infoValue}>2 dias completos</span>
                            </div>
                            <div>
                                <span className={styles.infoLabel}>Carga horária</span>
                                <span className={styles.infoValue}>10 horas</span>
                            </div>
                        </div>
                        <p className={styles.note}>
                            O horário poderá ser estendido para melhor aproveitamento das alunas.
                        </p>

                        <div className={styles.priceRow}>
                            <div>
                                <span className={styles.infoLabel}>Investimento total</span>
                                <span className={styles.priceValue}>R$ 1.100</span>
                            </div>
                            <div>
                                <span className={styles.infoLabel}>Valor em dupla</span>
                                <span className={styles.priceDuo}>R$ 900</span>
                                <span className={styles.priceHint}>por pessoa</span>
                            </div>
                        </div>

                        <div className={styles.reserve}>
                            <span className={styles.reserveTitle}>Para garantir sua vaga</span>
                            <span className={styles.reserveText}>
                                PIX de reserva no valor de <strong>R$ 100,00</strong>
                            </span>
                            <span className={styles.reserveHint}>Valor descontado do total do curso</span>
                        </div>

                        <p className={styles.warning}>
                            <strong>Importante:</strong> após a realização do pagamento, não haverá reembolso do valor
                            pago.
                        </p>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>O que você vai aprender</h3>
                        <ul className={styles.list}>
                            {APRENDER.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h3 className={styles.sectionTitle}>O que está incluso</h3>
                        <ul className={styles.list}>
                            {INCLUSO.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className={styles.ctaSection}>
                        <p className={styles.ctaTitle}>Vagas limitadas</p>
                        <p className={styles.ctaText}>
                            Reserve agora com o PIX de R$ 100,00 e garanta sua vaga no próximo curso.
                        </p>
                        <button type="button" className={styles.ctaButton} onClick={openWhatsApp}>
                            Quero garantir minha vaga
                        </button>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Curso_isabellacoimbra_sobrancelhas;
